module.exports = __webpack_public_path__ + "static/media/payment-bca.eda9aabe.png";